import { getPrescriptionOrderDetails, trackNow } from 'aster-foundation/core/epharmacy/myorders/redux/actions';
import { getUploadedRxDetails } from 'aster-foundation/core/epharmacy/uploadRX/redux/actions';
import Image from 'next/dist/client/image';
import { useRouter } from 'next/dist/client/router';
import PropTypes from 'prop-types';
import { default as React, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { IC_ATTACH_GREY, IC_EXPRESS_SHEDULED_DELIVERY, IC_DOCTOR_IGP, IC_EXPRESS_SHIPMENT_GIF } from '../../Assets/images';
import useWindowDimensions from '../../Context/useWindowDimensions';
import { dataLayerSendEvent, upcomingCardClick } from '@common/Utility/analytics-utils';
import {
  errorHandlingEpharmacy,
  getConfigurationValue,
  getReferralPageForGA,
  MIN_MOBILE_WIDTH,
  getImageUrlWithSize,
} from '@common/Utility/common-utils';
import { AE_GLOBAL, ERX_CONSTANTS, HOME_CARE_ROUTE, SCHEDULED_EXPRESS_FLAG, SCREEN_NAME, TELECONSULT_ROUTE } from '@common/Utility/constants';
import logger from '@common/Utility/logger';
import OrderTrackPopUp from '../OrderTrackPopUp/OrderTrackPopUp';
import SlickSlider from '../SlickSlider/SlickSlider';
import VerificationStatus from '../VerificationStatus/VerificationStatus';
import { UpcomingCardStyled } from './UpcomingCardStyled';
import { flagsmith } from '../../Lib/Flagsmith';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';

const responsive = [
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 820,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 480,
    settings: {
      variableWidth: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 390,
    settings: {
      slidesToShow: 0.8,
      slidesToScroll: 0.8,
    },
  },
  {
    breakpoint: 375,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
  {
    breakpoint: 360,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
    },
  },
];
const verifiedStatus = ['Confirmed', 'Out for Delivery'];
const PendingStatus = ['Fee Under Process', 'Pending', 'Order Processing'];
const cancelledStatus = ['cancelled'];
const receivedStatus = ['Received'];
const getStatusClass = (label) => {
  let status = '';
  if (verifiedStatus.includes(label)) {
    status = 'verified';
  }
  if (PendingStatus.includes(label)) {
    status = 'pending';
  }
  if (cancelledStatus.includes(label)) {
    status = 'incomplete';
  }
  if (receivedStatus.includes(label)) {
    status = 'Received';
  }
  return status;
};

const UpcomingCard = (props) => {
  const dispatch = useDispatch();
  const windowWidth = useWindowDimensions();
  const router = useRouter();
  const generateURL = useNavigationURL();
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry[0]?.resource);
  const appConfigData = useSelector((state) => state?.astercore?.AppConfig?.data?.data);
  const [orderType, setOrderType] = useState('');
  const [intervalTime, setIntervalTime] = useState();
  const [selectedOrderDetail, setSelectedOrderDetails] = useState();
  const [trackId, setTrackId] = useState('');
  const [isTrack, setIsTrack] = useState(false);
  const [isIdPresent, setIsIdPresent] = useState(true);
  const [trackingInformation, setTrackingInformation] = useState();
  const [ordersItems, setOrdersItems] = useState([]);
  const [erxTrackId, setErxTrackId] = useState('');
  const [pomTrackId, setPomTrackId] = useState([]);
  const [vcpOrderId, setVcpOrderId] = useState('');
  const pageType = getReferralPageForGA(router?.asPath);
  const screenName = router?.pathname;
  const ae_web_scheduled_express = flagsmith.getValue(SCHEDULED_EXPRESS_FLAG, { json: true });
  const isSheduledExpress = ae_web_scheduled_express?.isSheduledExpress;

  const getTrackShipmentData = (trackingId) => {
    if (userLogin?.id && (vcpOrderId ||trackingId)) {
      const trackItemId = {
        orderNumbers: [
          {
            ...(trackingId ? { orderNo: trackingId } : {}),
            vcpOrderId: vcpOrderId,
          },
        ],
      };
      dispatch(
        trackNow({
          params: trackItemId,
          onSuccess: (response) => {
            setTrackingInformation(response);
            if (response?.orderStatus) {
              setOrdersItems(response?.orderStatus);
            }
          },
          onFailure: (err) => {
            errorHandlingEpharmacy(err, true);
          },
        }),
      );
    }
  };

  const handleErxData = (item) => {
    setErxTrackId(item?.erxId);
    setPomTrackId(item);
    setVcpOrderId(item?.orderData?.id);
    if (item?.rxOrder) {
      dispatch(
        getPrescriptionOrderDetails({
          params: item?.erxId,
          onSuccess: (response) => {
            setSelectedOrderDetails(response);
            setTrackingInformation(response);
            if (response?.files) {
              setOrdersItems(response.files);
            }
            setOrderType(item?.type);
            setIsTrack(true);
          },
          onFailure: (error) => {
            errorHandlingEpharmacy(error, true, screenName, pageType);
            logger.error('Prescription Order Fetch details error', error);
          },
        }),
      );
    } else if (item?.type === ERX_CONSTANTS.PRESCRIPTION) {
      dispatch(
        getUploadedRxDetails({
          params: {
            erxId: item?.erxId,
          },
          onSuccess: (response) => {
            setSelectedOrderDetails(response);
            if (response?.files) {
              setOrdersItems(response.files);
            }
            setOrderType(item?.type);
            setIsTrack(true);
          },
          onFailure: (error) => {
            errorHandlingEpharmacy(error, true, screenName, pageType);
            logger.error('Erx Fetch details error', error);
          },
        }),
      );
    } else {
      setSelectedOrderDetails(item?.orderData);
      setOrderType(item?.type);
      setTrackId(item?.orderData.trackId);
      setIsTrack(true);
    }
  };

  useEffect(() => {
    if (appConfigData?.length > 0) {
      const value = getConfigurationValue(appConfigData, 'shipmentUpdateInterval');
      setIntervalTime(Number(value));
    }
  }, [appConfigData]);

  useEffect(() => {
    const erxDetails = {
      type: 'Prescription',
      id: erxTrackId,
    };
    if (isTrack && intervalTime > 0) {
      const interval = setInterval(() => {
        if (orderType === ERX_CONSTANTS.SHIPMENT) {
          getTrackShipmentData(trackId);
        }
        if (erxTrackId && orderType === ERX_CONSTANTS.PRESCRIPTION) {
          handleErxData(pomTrackId || erxDetails);
        }
      }, intervalTime * 1000);
      return () => clearInterval(interval);
    }
  }, [isTrack, intervalTime,vcpOrderId]);

  useEffect(() => {
    if (!trackId) {
      setIsIdPresent(false);
    }
    if (((trackId !== undefined && trackId !== null) || vcpOrderId)) {
      getTrackShipmentData(trackId);
    }
  }, [trackId, isTrack,vcpOrderId]);

  const navigateToDetail = async (type, id, data) => {
    if (type === 'Shipment' || data?.type === ERX_CONSTANTS.PRESCRIPTION) {
      upcomingCardClick(props?.screenName, type);
      setTrackId(data?.trackId);
      setVcpOrderId(data?.id);

      handleErxData(data);
      // router.push({ pathname: `${ONLINE_PHARMACY_ROUTE}/myorders/${id}` });
    }
    if (type === 'Appointment') {
      upcomingCardClick(props?.screenName, type);
      localStorage.setItem('appointmentFilterName', 'UPCOMING');
      router.push({ pathname: generateURL(`${TELECONSULT_ROUTE}/appointments/detail/${id}`), query: { type: 'UPCOMING', referrerPage: 'homepage' } });
    }
    if (type === 'HOME') {
      upcomingCardClick(props?.screenName, type);
      dataLayerSendEvent('appointment_view_detail', {
        booking_id: data?.id,
        appointment_mode: 'Homecare',
        service_type: 'NA',
        screen_name: props?.screenName,
      });
      router.push({ pathname: generateURL(`${HOME_CARE_ROUTE}/appointments/detail/${id}`) });
    }
  };

  const handleClose = () => {
    setIsTrack(!isTrack);
    setOrdersItems([]);
  };

  const getBorderClassName = (item) => {
    if (item?.rxOrder) {
      return AE_GLOBAL?.POM;
   }
    if (item?.type === AE_GLOBAL.SHIPMENT) {
       return item?.method;
    }

    return item?.type;
  };

  return (
    <UpcomingCardStyled>
      <Container className="upcomingApp">
        <SlickSlider
          sliderSettings={{
            slidesToShow: 2.9,
            infinite: false,
            className: props?.data?.length > 0 && 'appUpcomingOrdersSlider',
            responsive,
            dots: true,
            slidesToScroll: 2.9,
          }}
        >
          {props?.data?.map(
            (item) => (
              (
                <div className="px-2">
                  <div
                    className={`upcomingcard ${getBorderClassName(item)}`}
                    key={item?.id}
                    onClick={() => navigateToDetail(item.type, item?.id, item)}
                  >
                    <div className="daytime">
                      <div className="datetime">
                        <div className="date">
                          {item?.date}
                        </div>
                        {(item?.type !== 'Shipment' && !item?.rxOrder) && <div className="time">{item?.time}</div>}
                      </div>
                      <div className="status">
                        <VerificationStatus withoutIcon status={getStatusClass(item?.status)} label={item?.status} />
                      </div>
                    </div>
                    <div className="upcomingdetail">
                      <div className="img">
                        <div className={`${item?.type !== 'Shipment' && !item?.rxOrder ? 'round' : ''}`}>
                          {item?.rxOrder ? (
                            <Image src={IC_EXPRESS_SHIPMENT_GIF} height={46} width={53} />
                          ) : (
                            <Image
                              src={
                                item?.orderData?.status === SCREEN_NAME?.SCHEDULED_EXPRESS && isSheduledExpress
                                  ? IC_EXPRESS_SHEDULED_DELIVERY
                                  : item?.cardImage || IC_DOCTOR_IGP
                              }
                              height={46}
                              width={53}
                            />
                          )}
                          {item?.type === 'Appointment' && (
                            <div className="bottomicon">
                              <Image src={item?.appointmentTypeImage} height={24} width={24} />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="info">
                        <div
                          className={`subtitle ${item?.type !== 'Appointment' && 'order-2'}`}
                          title={item?.itemsList}
                        >
                          {item?.type === 'Prescription' && !item?.rxOrder && (
                            <span>
                              <Image src={IC_ATTACH_GREY} height={16} width={15} />
                            </span>
                          )}
                          <div>{item?.rxOrder ? item?.itemsList : item?.subTitle}</div>
                        </div>
                        <div className="title ms-0" title={item?.rxOrder ? 'Prescription Medicines' : item?.title}>
                          {item?.rxOrder ? 'Prescription Medicines' : item?.title}
                        </div>
                        {item?.type !== 'Shipment' && item?.type !== 'Prescription' && (
                          <div className="patient">
                            <span>Patient: </span>
                            {item?.patientName}
                          </div>
                        )}
                      </div>
                      {item?.type !== 'Appointment' && item?.moreCount > 0 && (
                        <div className={`more ${item?.type}`}>
                          <div>+{`${item?.moreCount} ${item?.rxOrder ? 'items' : item?.moreData}`}</div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )
            ),
          )}
        </SlickSlider>
      </Container>
      {isTrack && ordersItems?.length > 0 && (
        <OrderTrackPopUp
          orderDetails={selectedOrderDetail}
          trackInfo={trackingInformation}
          close={handleClose}
          isIdPresent={isIdPresent}
          orderType={orderType}
          isSheduledExpress={isSheduledExpress}
          isMobile={windowWidth?.width <= MIN_MOBILE_WIDTH}
        />
      )}
    </UpcomingCardStyled>
  );
};

UpcomingCard.propTypes = {
  data: PropTypes.object,
  screenName: PropTypes.string,
};

export default UpcomingCard;
